import BaseComponent from "@js/components/base_component.jsx";
import Select2 from "@js/components/widgets/select2.jsx";

// Index page search bar. In addition to the free-text `q` search, callers may
// pass `filters` — an array of { name, value, blankLabel, options: [{ value,
// label }] } — which render as select dropdowns. Changing a filter navigates
// immediately, carrying the current text search and the other filters along,
// so every control echoes its selection back the same way `q` does.
class EuiIndexSearchBar extends BaseComponent {

  static defaultProps = {
    filters: [],
  };

  constructor(props) {
    super(props);

    const filterValues = {};
    props.filters.forEach((filter) => { filterValues[filter.name] = filter.value || ""; });

    this.state = {
      q: props.q,
      filterValues: filterValues,
    };
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-offset-0 col-sm-8">
            { this.props.filters.length > 0 && (
              <form method="GET" className="form-inline" style={{ marginBottom: "8px" }}>
                { this.props.filters.map((filter) => (
                  <span key={ filter.name } style={{ display: "inline-block", marginRight: "8px", verticalAlign: "middle" }}>
                    <Select2
                      value={ this.state.filterValues[filter.name] }
                      options={ [ { value: "", label: filter.blankLabel } ].concat(filter.options) }
                      onChange={ (value) => this._onFilterChange(filter.name, value) }
                      width="180px"
                      search={ false }
                    />
                  </span>
                )) }
              </form>
            )}
            {this.props.q &&
              I18n.t("phrases.showing_search_results_for_q", {
                q: this.props.q
              })}
          </div>
          <div className="col-sm-4">
            <form method="GET" onSubmit={ this._onSearch }>
              <div className="input-group">
                <span className="input-with-clear-icon">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={ this.props.placeholder }
                    onChange={ e => this.setState({ q: e.target.value }) }
                    defaultValue={ this.props.q }
                  />
                  {
                    this.state.q &&
                      <span onClick={ this._onClearSearch }>&times;</span>
                  }
                </span>
                <span className="input-group-btn">
                  <button type="submit" className="btn btn-primary">
                    <i className="fa fa-search" />
                  </button>
                </span>
              </div>
            </form>
          </div>
        </div>
        <br />
      </div>
    );
  }

  // Builds the query params from the current text search and filter selections,
  // applies any overrides, drops blanks, and navigates.
  _visit(overrides) {
    const params = Object.assign({ q: this.state.q }, this.state.filterValues, overrides || {});

    Object.keys(params).forEach((key) => {
      if (params[key] === "" || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    Turbolinks.visit(this.props.indexPath(params));
  }

  _onFilterChange(name, value) {
    // Navigate immediately with the new selection. We don't setState first: it
    // would re-render (and re-init the Select2 widget) mid-navigation for no
    // benefit, since the page reloads with the value echoed back from the server.
    this._visit({ [name]: value });
  }

  _onClearSearch(e) {
    e.preventDefault();
    // Clear the text search but keep any active filters.
    this._visit({ q: "" });
  }

  _onSearch(e) {
    e.preventDefault();
    this._visit();
  }

}

export default EuiIndexSearchBar;
